import { C } from "./theme";

// The lead-in paragraph under or above a page's heading (Home and Learn). A function, so it
// reads the theme at render time.
// A dropdown, as the editors and the Goals page's filter draw it.
export const selectStyle = () => ({ width: "100%", minHeight: 44, background: C.surface2, border: `1px solid ${C.border}`, borderRadius: C.rsm, padding: "0 14px", fontSize: 16, fontFamily: "inherit" });

// A section's heading over a list (a goal's Tasks, Key Dates' Coming up): small capitals, readable grey.
export const sectionLabel = () => ({ margin: 0, fontSize: 13, fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase", color: C.textMid });

export const intro = () => ({ margin: 0, fontSize: 15, lineHeight: 1.5, color: C.textMid });
